module.exports = __webpack_public_path__ + "img/your-flow-runs.c193ba12.svg";